import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css' // 引入 Element Plus 的样式
// import { zhCn } from 'element-plus/es/locale' // 引入中文语言包
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import LanguageSwitch from 'vue-language-switch'
import { createHead } from '@vueuse/head'
import Pagination from './components/Pagination/Pagination.vue'

const head = createHead()
const app = createApp(App)
// eslint-disable-next-line vue/multi-word-component-names
app.component('Pagination', Pagination)
app.use(ElementPlus)
// app.use(ElementPlus, {
//   locale: zhCn // 配置Element Plus为中文
// })
app.use(router)
app.use(head)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component) // 注册图标组件
}
// 配置语言选项
app.use(LanguageSwitch, {
  languages: [
    { code: 'en', name: 'English' },
    { code: 'zh', name: '中文' },
  ],
  defaultLanguage: 'zh' // 默认语言
})
app.mount('#app')
